import { Injectable } from '@angular/core';
import { ContactOurExpertsConnector } from './contact-our-experts.connector';
import { ContactForm } from './contact-our-experts.model';

@Injectable({
  providedIn: 'root',
})
export class ContactOurExpertsService {
  constructor(private contactOurExpertsConnector: ContactOurExpertsConnector) {}

  getSupportTopics() {
    return this.contactOurExpertsConnector.getSupportTopics();
  }

  getSubTopics(topicCode: string) {
    return this.contactOurExpertsConnector.getSubTopics(topicCode);
  }

  getOption(subTopicCode: string) {
    return this.contactOurExpertsConnector.getOption(subTopicCode);
  }

  submitContactForm(formValue: ContactForm) {
    return this.contactOurExpertsConnector.submitContactForm(formValue);
  }
}
